export default __webpack_public_path__ + "static/media/labour-day.c743b554.webp";